import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from '../../../utils/api';

export interface SchoolFeatureConfig {
  id: number;
  abandonedNotificationsEnabled: boolean;
  abandonedNotificationIntervalDays: number;
  abandonedNotificationMaxReminders: number;
  abandonedNotificationEmailTemplateCode: string;
  allowCourseChange: boolean;
  courseChangeLockStage: number;
  concentrationSelectionEnabled: boolean;
  allowPostRejectionOverride: boolean;
  postRejectionOverrideRoles: string;
  postRejectionTargetStatus: string;
  autoProvisionCredentials: boolean;
  usernameFormat: number;
  defaultPasswordFormat: number;
  generateMatricBeforeMove: boolean;
}

interface SchoolConfigResponse {
  code: number;
  message: string;
  data: SchoolFeatureConfig;
}

export const GET_SCHOOL_CONFIG_QUERY_KEY = ['get-school-config'];

export const useGetSchoolConfigQuery = () => {
  const fetchSchoolConfig = async (): Promise<SchoolConfigResponse> => {
    return (await api.get('/SchoolFeatureConfig'))?.data;
  };

  const { data, isLoading, isError, error, refetch } = useQuery<SchoolConfigResponse, AxiosError<ApiErrorResponse>>({
    queryKey: GET_SCHOOL_CONFIG_QUERY_KEY,
    queryFn: fetchSchoolConfig,
  });

  const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch school config';

  return {
    data,
    schoolConfigData: data?.data,
    isLoading,
    isSchoolConfigLoading: isLoading,
    isError,
    isSchoolConfigError: isError,
    errorMessage,
    schoolConfigErrorMessage: errorMessage,
    refetch,
  };
};
